const settings = {
  https: false,
  apiUrl: process.env.VITE_API_URL,
  isDevelopment: Boolean(process.env.VITE_TELEGRAM_IS_DEV),
};

export default settings;
